export default defineAppConfig({
    name: "Boosting Market",
});
